import { z } from 'zod';

export const bulkMessageGenerationRequestSchema = z.object({
  prompt: z.string().describe('Prompt or context for message generation'),
  tone: z
    .enum(['promotional', 'informational', 'reminder', 'greeting', 'friendly'])
    .optional()
    .describe('Tone of the message'),
  includeVariables: z.array(z.string()).optional().describe('Variables to include in the message'),
  additionalRequirements: z.string().optional().describe('Additional requirements for the message'),
  language: z.string().default('es').describe('Language for generation'),
});

export const bulkMessageSchema = z.object({
  message: z.string().describe('Generated message with variables'),
  tone: z
    .enum(['promotional', 'informational', 'reminder', 'greeting', 'friendly'])
    .describe('Tone of the message'),
  usedVariables: z.array(z.string()).describe('Variables used in the message'),
  suggestions: z.array(z.string()).optional().describe('Additional message suggestions'),
});

export type BulkMessageGenerationRequest = z.infer<typeof bulkMessageGenerationRequestSchema>;
export type BulkMessage = z.infer<typeof bulkMessageSchema>;
